<template>
  <div id="title">

    <!-- AppTitle Area Start -->
    <div class="title">
      <div class="logo">
        <h1>A : Young</h1>
      </div>
      <div class="menu">
        <ul>
          <router-link to="/home">
            <li>
              <p class="Home">Home</p>
            </li>
          </router-link>

          <router-link to="/about">
            <li>
              <p class="About">About</p>
            </li>
          </router-link>

          <router-link to="/skill">
            <li>
              <p class="Skill">Skill</p>
            </li>
          </router-link>

          <router-link to="/portfolio">
            <li>
              <p class="Portfolio">Portfolio</p>
            </li>
          </router-link>
          <router-link to="/contact">
            <li>
              <p class="Contact">Contact</p>
            </li>
          </router-link>

        </ul>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Title"
}
</script>

<style lang="scss" scoped>
@import '../../sass/partials/mixin', '../../sass/partials/variable';

#title {
  .title {
    width: 100%;
    height: 90px;
    background-color: $m-bg1;
    color: $color1;

    h1 {
      text-align: center;
      font: bold 25px "Lato", sans-serif;
      padding: 13px 0 10px 0;
    }

    .menu {
      ul {
        @include flex(true, 'space-around', 'center', 0);

        li {
          &:hover p {
            color: $t-c1;
          }

          p {
            padding: 10px;
            color: $bg-color1;
            @include font-set(500, 13px, 13px, $ff4);
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/component/Header.vue